import {Box, HStack, Show} from 'platform/foundation';

import {useCountByQueryId, useDetailPagination} from 'features/datagrid';

import {useEntityNavigation} from '../../../hooks/useEntityNavigation';
import {NavigationButton} from './NavigationButton';

export function EntityHeaderNavigation() {
  const {handleBreadcrumb, handleNavigate, isRowControlDetailVisible} = useEntityNavigation();
  const {rowIndex, isInvalid, onPageChange, isLoading} = useDetailPagination(handleNavigate);
  const {count, hasSourceParams} = useCountByQueryId();

  const handlePrevPage = () => {
    if (rowIndex === 1) {
      return;
    }

    onPageChange(rowIndex - 1);
  };

  const handleNextPage = () => {
    if (rowIndex === count) {
      return;
    }

    onPageChange(rowIndex + 1);
  };

  const showNavigation = isRowControlDetailVisible && hasSourceParams && !isInvalid;

  return (
    <Box position="absolute" top={0} left={0} padding={3} width="100%" zIndex="PAGE_NAVIGATION">
      <HStack justify="space-between" width="100%">
        <NavigationButton icon="navigation/arrow_back" onClick={handleBreadcrumb} />

        <Show when={showNavigation}>
          <HStack spacing={2}>
            <NavigationButton
              isDisabled={isLoading || rowIndex === 1}
              icon="navigation/arrow_back_ios"
              onClick={handlePrevPage}
            />

            <NavigationButton
              isDisabled={isLoading || rowIndex === count}
              icon="navigation/arrow_forward_ios"
              onClick={handleNextPage}
            />
          </HStack>
        </Show>
      </HStack>
    </Box>
  );
}
